import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about-hero-section',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about-hero-section.component.html',
  styleUrl: './about-hero-section.component.scss'
})
export class AboutHeroSectionComponent {
  @Input({ required: true }) aboutValues: string[] = [];
}
